module.exports = __webpack_public_path__ + "static/media/htmlPro2.e8b4ad10.PNG";